import { useState, useEffect, useRef } from 'react';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';

let string = '';

function PingPad(props) {
  const { show, setShow, run, center, close, optionText } = props;
  const [input, setInput] = useState('');
  const rf = useRef(null);

  // useEffect(() => {
  //   setInput('');
  //   string = '';
  // }, [show]);

  // useEffect(() => {
  //   setInput('');

  //   function handleEsc(event) {
  //     // console.log('event.key', event.key);
  //     if (event.key === 'Enter') {
  //       // run(string);
  //       // string = '';
  //     } else if (event.key === 'Backspace') {
  //       // console.log('event.key', event.key);
  //       if (string.length > 0) {
  //         string = string.substring(0, string.length - 1);
  //         setInput(string);
  //       }
  //     } else {
  //       string += event.key;
  //       setInput(string);
  //     }
  //   }

  //   window.addEventListener('keydown', handleEsc);

  //   return () => {
  //     window.removeEventListener('keydown', handleEsc);
  //   };
  // }, []);

  const onChange = (input) => {
    setInput(input);
  };

  const onKeyPress = (button, e) => {
    if (button === '{close}') {
      rf?.current.clearInput();
      setInput('');
      if (close) {
        e.preventDefault();
        setShow(false);
      }
    }
    if (button === '{enter}') {
      run(input);
    }
  };

  const mylayout = {
    default: ['1 2 3', '4 5 6', '7 8 9', '{close} 0 {enter}'],
    shift: ['! / #', '$ % ^', '& * (', '{shift} ) +'],
  };

  const display = {
    '{enter}': '✓',
    '{close}': '✕',
    // "{bksp}": "backspace",
  };

  const buttonTheme = [
    // {
    //   class: 'button-length1',
    //   buttons: '{enter} {close} ',
    // },
    {
      class: 'button-height1',
      buttons: '1 2 3 4 5 6 7 8 9 0',
    },
    {
      class: 'button-back1',
      buttons: '{bksp}',
    },
  ];

  return (
    <div className={`PingPad ${center ? 'centered' : ''}`}>
      {show && (
        <div style={{ width: '300px', margin: 'auto' }}>
          {optionText && (
            <div
              style={{
                textAlign: 'center',
                marginBottom: '15px',
                padding: '12px 16px',
                fontSize: '14px',
                fontWeight: '500',
                color: '#2c3e50',
                backgroundColor: '#f8f9fa',
                border: '1px solid #e9ecef',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}
            >
              {optionText}
            </div>
          )}
          <input value={input} type="password" className="keyboard-num-input" onChange={() => {}} />
          <Keyboard
            id="my-keyboard-num"
            onChange={onChange}
            keyboardRef={(r) => (rf.current = r)}
            layout={mylayout}
            onKeyPress={onKeyPress}
            preventMouseDownDefault={true}
            buttonTheme={buttonTheme}
            display={display}
          />
        </div>
      )}
    </div>
    /* </ClickOutSideDiv> */
  );
}

export default PingPad;
